import { darken, lighten } from '@mui/material';
import { createTheme } from '@mui/material/styles';

const { palette } = createTheme();
const { augmentColor } = palette;
const createColor = (mainColor: string, name: string) =>
  augmentColor({
    color: {
      main: mainColor,
      dark: darken(mainColor, 0.45),
      light: lighten(mainColor, 0.25),
      contrastText: '#fff',
    },
    name: name,
  });

export interface BrandPalette {
  gradientStart: string;
  gradientEnd: string;
  success: {
    light: string;
    main: string;
    dark: string;
    contrastText: string;
  };
  primary: {
    light: string;
    main: string;
    dark: string;
    contrastText: string;
  };
  secondary: {
    light: string;
    main: string;
    dark: string;
    contrastText: string;
  };
}

const basePalette: BrandPalette = {
  gradientStart: '#131742',
  gradientEnd: '#1B457B',
  success: createColor('#5c9a72', 'success'),
  primary: createColor('#5c9a72', 'primary'),
  secondary: createColor('#131742', 'secondary'),
};

export type BrandPaletteKeys =
  | 'maxmyinterest.com'
  | 'alliancebernstein.com'
  | 'fieldpointprivate.com';

export enum BrandPaletteKeysEnum {
  MaxMyInterest = 'maxmyinterest.com',
  AllianceBernstein = 'alliancebernstein.com',
  FieldPointPrivate = 'fieldpointprivate.com',
}

export const brandPalettes: Record<BrandPaletteKeys, BrandPalette> = {
  'maxmyinterest.com': basePalette,
  'alliancebernstein.com': {
    ...basePalette,
    gradientStart: '#000000',
    gradientEnd: '#484747',
    primary: createColor('#1e9bd7', 'primary'),
    secondary: createColor('#000000', 'secondary'),
  },
  'fieldpointprivate.com': {
    ...basePalette,
    gradientStart: '#394154',
    gradientEnd: '#6f7fa4',
    primary: createColor('#6da2d4', 'primary'),
    secondary: createColor('#394154', 'secondary'),
  },
};
